import { useEffect } from "react";
import { Navigate, useParams } from "react-router-dom";
import { TOURS } from "@/lib/tours";
import Nav from "@/components/landing/Nav";
import Footer from "@/components/landing/Footer";
import FloatingWhatsApp from "@/components/landing/FloatingWhatsApp";
import TourHero from "@/components/tour/TourHero";
import TourOverview from "@/components/tour/TourOverview";
import TourItinerary from "@/components/tour/TourItinerary";
import TourGallery from "@/components/tour/TourGallery";
import TourIncluded from "@/components/tour/TourIncluded";
import OtherTours from "@/components/tour/OtherTours";

const DEFAULT_TITLE = "Darlei Guia RJ | Guia de Turismo no Rio de Janeiro";

export default function TourPage() {
  const { slug } = useParams();
  const tour = TOURS.find((t) => t.slug === slug);

  useEffect(() => {
    if (!tour) return;
    const meta = document.querySelector('meta[name="description"]');
    const prevDesc = meta?.getAttribute("content");
    document.title = `${tour.name} | Darlei Guia RJ`;
    meta?.setAttribute("content", tour.description);
    return () => {
      document.title = DEFAULT_TITLE;
      if (prevDesc) meta?.setAttribute("content", prevDesc);
    };
  }, [tour]);

  if (!tour) return <Navigate to="/" replace />;

  return (
    <div data-testid={`tour-page-${tour.slug}`}>
      <Nav />
      <main>
        <TourHero tour={tour} />
        <TourOverview tour={tour} />
        <TourItinerary tour={tour} />
        <TourGallery tour={tour} />
        <TourIncluded tour={tour} />
        <OtherTours current={tour} />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}
